module.exports = __webpack_public_path__ + "img/network_off_dark.94818c8a.svg";